import {
	GET_USER_CONVERSATIONS,
	GET_USER_CONVERSATIONS_SUCCESS,
	GET_USER_CONVERSATIONS_FAIL,
	GET_USER_CONVERSATIONS_RESET,
} from '../actions/getUserConversationsAction';

const initialState = {
	apiState: '',
	message: '',
	data: null,
	error: '',
};

const getUserConversationsReducer = (state = initialState, action) => {
	switch (action.type) {
		case GET_USER_CONVERSATIONS:
			return {
				...state,
				apiState: 'loading',
			};
		case GET_USER_CONVERSATIONS_SUCCESS:
			return {
				...state,
				apiState: 'success',
				data: action.response.data,
				message: action.response.message || 'success',
			};
		case GET_USER_CONVERSATIONS_FAIL:
			return {
				...state,
				apiState: 'error',
				error: action.response.errors || null,
				message: action.response.message || 'error',
			};
		case GET_USER_CONVERSATIONS_RESET:
			return initialState;
		default:
			return state;
	}
};

export default getUserConversationsReducer;
